/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Not_Ready_BodyInputs */

const en_us2_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`A week's report is ready when the week closes, on Sunday night, and covers everything you trained in it.`);
	return /** @type {LocalizedString} */ (`A month's report is ready when the month closes, and covers everything you trained in it.`)
	
};

const pt_br2_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`O relatório de uma semana sai quando ela fecha, no domingo à noite, e conta tudo o que você treinou nela.`);
	return /** @type {LocalizedString} */ (`O relatório de um mês sai quando ele fecha, e conta tudo o que você treinou nele.`)
	
};

const es_419_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`El informe de una semana está listo cuando la semana cierra, el domingo en la noche, e incluye todo lo que entrenaste en ella.`);
	return /** @type {LocalizedString} */ (`El informe de un mes está listo cuando el mes cierra, e incluye todo lo que entrenaste en él.`)
	
};

const pt_pt2_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`O relatório de uma semana sai quando ela fecha, no domingo à noite, e conta tudo o que treinaste nela.`);
	return /** @type {LocalizedString} */ (`O relatório de um mês sai quando ele fecha, e conta tudo o que treinaste nele.`)
	
};

const fr_fr2_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Le bilan d'une semaine est prêt à sa clôture, le dimanche soir, et couvre tout ce que tu y as fait.`);
	return /** @type {LocalizedString} */ (`Le bilan d'un mois est prêt à sa clôture, et couvre tout ce que tu y as fait.`)
	
};

const de_de2_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Der Wochenbericht ist fertig, wenn die Woche endet, am Sonntagabend, und umfasst alles, was du in ihr trainiert hast.`);
	return /** @type {LocalizedString} */ (`Der Monatsbericht ist fertig, wenn der Monat endet, und umfasst alles, was du in ihm trainiert hast.`)
	
};

const it_it2_progress_report_not_ready_body = /** @type {(inputs: Progress_Report_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Il report di una settimana è pronto quando la settimana si chiude, la domenica sera, e conta tutto ciò che hai allenato in quei giorni.`);
	return /** @type {LocalizedString} */ (`Il report di un mese è pronto quando il mese si chiude, e conta tutto ciò che hai allenato in quel mese.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "A week's report is ready when the week closes, on Sunday night, and covers everything you trained in it." |
* | * | "A month's report is ready when the month closes, and covers everything you trained in it." |
*
* @param {Progress_Report_Not_Ready_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_not_ready_body = /** @type {((inputs: Progress_Report_Not_Ready_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Not_Ready_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_not_ready_body(inputs)
	if (locale === "es-419") return es_419_progress_report_not_ready_body(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_not_ready_body(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_not_ready_body(inputs)
	if (locale === "de-DE") return de_de2_progress_report_not_ready_body(inputs)
	if (locale === "it-IT") return it_it2_progress_report_not_ready_body(inputs)
	return en_us2_progress_report_not_ready_body(inputs)
});
export { progress_report_not_ready_body as "progress-report.not_ready_body" }